import { useState } from 'react';

import {
  HStack,
  NewButton,
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
  VStack,
  legacyTextStyles,
} from '@eluve/components';
import { useAppointmentId } from '@eluve/frontend-appointment-hooks';

import { useTranscriptionMachineSelector } from './appointments/machines/transcription/hooks/useTranscriptionMachine';

export const TranscriptionConfidenceAlert: React.FC = () => {
  const appointmentId = useAppointmentId();
  const [userDismissed, setUserDismissed] = useState(false);

  const isMuted = useTranscriptionMachineSelector(
    (state) => state.context.microphoneStatus === 'muted',
  );

  const isAppointmentInSession = useTranscriptionMachineSelector(
    (state) => state.context.sessionAppointmentId === appointmentId,
  );

  const isLowConfidence = useTranscriptionMachineSelector(
    (state) => state.context.isLowConfidenceTranscription,
  );

  const isOpen = !userDismissed && isLowConfidence;
  const handleClose = () => setUserDismissed(true);

  if (!isAppointmentInSession || isMuted) return null;

  return (
    <div className="absolute bottom-full left-0">
      <Popover open={isOpen} onOpenChange={handleClose}>
        <PopoverTrigger asChild>
          <div className="pointer-events-none size-0.5" />
        </PopoverTrigger>
        <PopoverContent
          side="bottom"
          align="start"
          className="rounded-lg bg-text-primary px-2.5 py-1.5 text-white shadow-md"
        >
          <HStack justify="between" align="start">
            <VStack wFull>
              <span
                className={legacyTextStyles.body({
                  size: 's',
                  weight: 'semibold',
                  color: 'inherit',
                })}
              >
                Are you too far from your device?
              </span>
              <span
                className={legacyTextStyles.body({
                  size: 's',
                  color: 'supporting',
                })}
              >
                Try moving your device closer so that we can properly pick up
                the audio.
              </span>
            </VStack>
            <PopoverClose asChild>
              <NewButton icon={{ name: 'X' }} size="s" onClick={handleClose} />
            </PopoverClose>
          </HStack>
        </PopoverContent>
      </Popover>
    </div>
  );
};
